import React from 'react';
import ReactDOM from 'react-dom';

import CarInfo from './tire-change/components/CarInfo';
import Booking from './tire-change/components/Booking';
import Login from './tire-change/components/Login';
import Customer from './tire-change/components/Customer';


const BookingInfo = ({ changePhase }) => {
  return (
    <div id="tire-change-booking">
      <Login />
      <CarInfo />
      <Booking changePhase={changePhase}/>
    </div>
  )
};

const CustomerInfo = () => {
  return (
    <div id="tire-change-booking">
      <h2>3. Yhteystiedot ja maksaminen</h2>
      <Customer />
    </div>
  )
};

class TireChangeBooking extends React.Component {
  constructor(props) {
    super(props);
    this.phases = {
      0: BookingInfo,
      1: CustomerInfo,
    }
    this.state = {
      phase: 0,
    }
  }
  render() {
    const phaseId = this.state.phase,
      CurrentPhase = this.phases[phaseId];
    return <CurrentPhase changePhase={() => this.setState({phase: phaseId == 1 ? 0 : 1})} />;
  }
}

ReactDOM.render(<TireChangeBooking />, document.getElementById('tire-change-booking'));



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/tire-change-booking.js
 **/